var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 16.8L15 7.21C15 4 13 2 9.8 2H7.21C4.01 2 2.01 4 2.01 7.2L2.01 16.8C2 20 4 22 7.2 22H9.8C13 22 15 20 15 16.8Z",
    fill: "#EF4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4301 15.88L21.7801 12.53C22.0701 12.24 22.0701 11.76 21.7801 11.47L18.4301 8.12C18.1401 7.83 17.6601 7.83 17.3701 8.12C17.0801 8.41 17.0801 8.89 17.3701 9.18L19.4401 11.25L8.75006 11.25C8.34006 11.25 8.00006 11.59 8.00006 12C8.00006 12.41 8.34006 12.75 8.75006 12.75L19.4401 12.75L17.3701 14.82C17.2201 14.97 17.1501 15.16 17.1501 15.35C17.1501 15.54 17.2201 15.74 17.3701 15.88C17.6601 16.18 18.1301 16.18 18.4301 15.88Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.d8f0f0696a5f011ef86308fe58c24e08.svg";
export { ForwardRef as ReactComponent };